import { numberFormatter } from '../styles/GlobalStyles';

// Format a number for display in a currency-style text input. Returns '' for
// nullish / NaN inputs so the field renders empty rather than "$NaN".
export function toCurrencyInputString(value) {
    if (value == null || isNaN(Number(value))) return '';
    return numberFormatter.format(Math.round(Number(value)));
}

// Live-format a currency input as the user types — strips invalid chars,
// inserts thousands separators, and (when preservePartial) keeps mid-edit
// states like "0", trailing ".", or empty intact rather than normalizing to
// "0". Pair with a cursor-preservation handler since the formatted length
// changes mid-string when commas are inserted/removed.
export function formatCurrencyOnInput(val, preservePartial = true) {
    const cleaned = String(val ?? '').replace(/[^0-9.]/g, '');
    if (cleaned === '' || cleaned === '.') return cleaned;
    const parts = cleaned.split('.');
    let intPart = parts[0];
    if (!preservePartial && intPart.length > 1) {
        intPart = intPart.replace(/^0+(?=\d)/, '');
    }
    if (intPart === '') {
        const decimalPart = parts.length > 1 ? '.' + parts[1].slice(0, 2) : '';
        if (preservePartial) return parts[0] + decimalPart;
        return '0' + decimalPart;
    }
    const formatted = numberFormatter.format(parseInt(intPart, 10));
    if (parts.length > 1) return formatted + '.' + parts[1].slice(0, 2);
    return formatted;
}

// Parse a currency-input string (with optional commas) back into a number,
// or null if blank.
export function parseCurrencyInput(str) {
    if (str == null) return null;
    const cleaned = String(str).replace(/[^0-9.]/g, '');
    if (cleaned === '') return null;
    const n = Number(cleaned);
    return isNaN(n) ? null : n;
}
